<template>
    <div class="usp-xiaocan" v-if="moduleData.gif"><!-- data-ani="aniGroup" -->
        <div class="usp-xiaocan-bg aniBlock-bg">  <!--:data-animate="
            JSON.stringify([{ start: 0, end: 100, change: [2, 1], type: 's' }])
          "-->
           <img
            class="usp-xiaocan-bg-img "
            :src="moduleData.gif"
          />
          <!-- <img
            class="usp-xiaocan-bg-img pc"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623140554410-web_usp_02@1x.jpg"
          /> -->
          <!-- <img
            class="usp-xiaocan-bg-img pad"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624152143966-pad_usp_02@2x.jpg"
          />
          <img
            class="usp-xiaocan-bg-img mb"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624152143541-phone_usp_02@3x.jpg"
          /> -->
        </div>
        <!-- <div class="usp-xiaocan-text">
          <div class="usp-xiaocan-title"  >
              
            小CAN同学，IQ晋级
          </div>
          <div class="usp-xiaocan-desc aniBlock-desc" >
            智能语音机器人，可以连续对话，以及智能过滤非指令语句，为你完成车内80%以上的操作。
          </div>
        </div> -->
        <div class="usp-xiaocan-list">
          <div
            class="usp-xiaocan-item" 
            
            :class="'aniBlock-item-' + index"
            v-for="(item, index) in moduleData.bottomGroupPic"
            :key="index"
          >
            <img class="usp-xiaocan-item-img" :src="item" />
            <!-- <div class="usp-xiaocan-item-text">
              <div class="usp-xiaocan-item-title">{{ item.title }}</div>
              <div class="usp-xiaocan-item-desc">{{ item.desc }}</div>
            </div> -->
          </div>
        </div>
      </div>
</template>
<script>
export default {
     name: "xiaocan",
     props:{
      moduleData:{
        type:Object
      }
     },
     data() {
      return{}
     }
}
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
@include setThemeClass {
    .usp-xiaocan {
      position: relative;
      background-color: getThemeVal(navColorBlack);
      overflow: hidden;
      .usp-xiaocan-bg {
        @include media(
          (
            $home-sm: (
              position: absolute,
              top: 0,
              left: 0,
              right: 0,
              z-index: 1
            )
          )
        );
        .usp-xiaocan-bg-img {
          width: 100%;
          height: auto;
        }
      }
      .usp-xiaocan-text {
        position: absolute;
        top: vw(140);
        left: 20px;
        right: 20px;
        text-align: center;
        z-index: 2;
        @include media(
          (
            $home-md: (
              top: 80px
            )
          )
        );
        @include setThemeClass {
          .usp-xiaocan-title {
            @include h1-s(getThemeVal(brandColorWhite), vw);
            @include media(
              (
                $home-md: (
                  font-size: 36px,
                  line-height: 48px
                ),
                $home-sm: (
                  font-size: 28px,
                  line-height: 42px
                )
              )
            );
          }
          .usp-xiaocan-desc {
            margin-top: 20px;
            @include h3-s(getThemeVal(brandColorWhite), vw);
            @include media(
              (
                $home-md: (
                  margin-top: 10px,
                  font-size: 14px,
                  line-height: 30px
                )
              )
            );
          }
        }
      }
      .usp-xiaocan-list {
        position: absolute;
        left: 0;
        right: 0;
        bottom: vw(100);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        @include media(
          (
            $home-md: (
              bottom: 60px
            ),
            $home-sm: (
              display: block,
              position: relative,
              left: auto,
              right: auto,
              bottom: auto,
              z-index: 2,
              padding: 336px 20px 0
            )
          )
        );
        .usp-xiaocan-item {
          width: vw(328);
          @include media(
            (
              $home-md: (
                width: 220px
              ),
              $home-sm: (
                width: 100%,
                padding-bottom: 40px
              )
            )
          );
          .usp-xiaocan-item-img {
            width: 100%;
            height: auto;
            pointer-events: none;
          }
          .usp-xiaocan-item-text {
            margin-top: 30px;
            @include media(
              (
                $home-md: (
                  margin-top: 16px
                )
              )
            );
            text-align: center;
            @include setThemeClass {
              .usp-xiaocan-item-title {
                font-size: vw(20);
                font-weight: bold;
                color: getThemeVal(brandColorWhite);
                line-height: 30px;
                @include media(
                  (
                    $home-md: (
                      font-size: 20px,
                      line-height: 30px
                    )
                  )
                );
              }
              .usp-xiaocan-item-desc {
                margin-top: 10px;
                @include h4(getThemeVal(brandColorWhite), vw);
                line-height: 1.6;
                @include media(
                  (
                    $home-md: (
                      font-size: 14px,
                      line-height: 22px
                    )
                  )
                );
              }
            }
          }
        }
        .usp-xiaocan-item + .usp-xiaocan-item {
          margin-left: 24px;
          @include media(
            (
              $home-sm: (
                margin-left: 0
              )
            )
          );
        }
      }
    }
  }
</style>